/* LeParfin V4 : fiche produit (galerie, formule 1/3/5, choix des parfums avec quantités,
   « Avant d'acheter », barre d'achat collante, « Cliquez pour sentir »). Utilise window.LP (assets/theme.js).
   V8 : « Cliquez pour sentir » préchargé et défilement continu (voir la partie dédiée).
   Le choix des parfums est une liste d'unités : le même parfum peut y figurer plusieurs fois. */
(() => {
  'use strict';

  /* ---------- Logique pure du choix (testable sans navigateur) ---------- */
  const Pick = {
    /* { velora: 2, sevra: 1 } */
    counts(units) {
      const c = {};
      units.forEach((k) => { c[k] = (c[k] || 0) + 1; });
      return c;
    },
    /* Parfums dans l'ordre de première apparition. */
    keys(units) {
      return units.filter((k, i) => units.indexOf(k) === i);
    },
    /* Unités regroupées par parfum (pour la jauge et le récapitulatif). */
    grouped(units) {
      const out = [];
      Pick.keys(units).forEach((k) => units.forEach((x) => { if (x === k) out.push(k); }));
      return out;
    },
    /* Ajoute une unité. Si la sélection est complète, l'unité la plus ancienne d'un autre parfum
       est remplacée (celles du parfum de la fiche en dernier). Rien ne change si tout est déjà ce parfum. */
    add(units, key, total, protect) {
      const u = units.slice(0, total);
      if (u.length < total) { u.push(key); return u; }
      let i = u.findIndex((k) => k !== key && k !== protect);
      if (i < 0) i = u.findIndex((k) => k !== key);
      if (i < 0) return u;
      u.splice(i, 1);
      u.push(key);
      return u;
    },
    /* Retire une unité (la dernière ajoutée de ce parfum). */
    remove(units, key) {
      const u = units.slice();
      const i = u.lastIndexOf(key);
      if (i > -1) u.splice(i, 1);
      return u;
    },
    /* Même parfum pour toute la sélection. */
    same(key, total) {
      return Array.from({ length: total }, () => key);
    },
    /* Ajuste à la formule : coupe si trop long, complète avec des parfums différents (ordre prefs). */
    fit(units, total, prefs) {
      const u = units.slice(0, total);
      (prefs || []).forEach((k) => { if (u.length < total && !u.includes(k)) u.push(k); });
      return u;
    },
    /* « Velora ×2, Sevra » */
    summary(units, capOf) {
      const c = Pick.counts(units);
      return Pick.keys(units).map((k) => (capOf(k) || k) + (c[k] > 1 ? ' ×' + c[k] : '')).join(', ');
    },
    /* Lignes panier : [{ id, quantity }] regroupées par variante. */
    items(units, variantOf) {
      const out = [];
      units.forEach((k) => {
        const id = Number(variantOf(k));
        if (!id) return;
        const line = out.find((x) => x.id === id);
        if (line) line.quantity += 1; else out.push({ id, quantity: 1 });
      });
      return out;
    },
    /* Cases « offert » de la jauge (index 0) : la 3e, puis la 5e. */
    freeSlots(total) {
      return total >= 5 ? [2, 4] : total >= 3 ? [2] : [];
    }
  };

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module !== 'undefined' && module.exports) module.exports = { Pick };
    return;
  }
  if (window.__lpProductJs) return;
  window.__lpProductJs = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const fill = (tpl, map) => String(tpl || '').replace(/\[(\w+)\]/g, (m, k) => (k in map ? map[k] : m));
  const readJSON = (el) => { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } };
  const rootUrl = () => ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/');
  const reduced = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* V38 : ajoute un texte dont le prix (la valeur de la pochette, ex. « et la pochette 9,90 € offerte ») s'affiche barré,
     comme dans le panier et le Pack de Noël. Insertion en nœuds de texte, jamais en HTML. */
  function appendStruck(el, text) {
    const str = String(text || '').replace(/\s{2,}/g, ' ');
    const m = str.match(/\d+(?:[.,]\d{1,2})?[\s  ]?€/);
    if (!m) { el.appendChild(document.createTextNode(str)); return; }
    el.appendChild(document.createTextNode(str.slice(0, m.index)));
    const sr = document.createElement('span');
    sr.className = 'sr';
    sr.textContent = 'valeur ';
    const st = document.createElement('s');
    st.className = 'lp-pv';
    st.textContent = m[0];
    el.appendChild(sr);
    el.appendChild(st);
    el.appendChild(document.createTextNode(str.slice(m.index + m[0].length)));
  }

  function toast(msg) {
    if (!msg) return;
    if (window.LP && typeof LP.toast === 'function') LP.toast(msg);
  }

  const hasLP = () => !!(window.LP && LP.cart && typeof LP.cart.add === 'function');

  /* Ajout au panier : LP.cart.add (theme.js, qui affiche lui-même les erreurs), sinon /cart/add.js puis page panier. */
  function addItems(items) {
    if (hasLP()) return Promise.resolve(LP.cart.add(items, { open: true }));
    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    }).then((r) => {
      if (!r.ok) throw new Error('cart');
      window.location.href = rootUrl() + 'cart';
    });
  }

  /* V3.11 : chargement différé des images de la galerie à partir de la 3e (balises img[data-src], data-srcset).
     Mobile : la galerie défile horizontalement, l'image se charge quand sa figure est à moins d'une demi-largeur de l'écran.
     Ordinateur : grille, chargement 600 px avant l'entrée dans l'écran. Au moindre doute (pas d'IntersectionObserver, erreur),
     tout est chargé. */
  function lazyGallery(gal) {
    const imgs = $$('img[data-src]', gal);
    if (!imgs.length) return;
    const load = (img) => {
      const src = img.getAttribute('data-src');
      if (!src) return;
      const set = img.getAttribute('data-srcset');
      img.loading = 'eager';
      if (set) img.srcset = set;
      img.src = src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    };
    const all = () => imgs.forEach(load);
    try {
      if (!('IntersectionObserver' in window) || !window.matchMedia) { all(); return; }
      const mq = window.matchMedia('(min-width:1000px)');
      let io = null;
      const watch = () => {
        if (io) io.disconnect();
        io = new IntersectionObserver((es) => {
          es.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); load(e.target); } });
        }, mq.matches ? { rootMargin: '600px 0px 600px 0px' } : { root: gal, rootMargin: '0px 55% 0px 55%' });
        imgs.forEach((i) => { if (i.getAttribute('data-src')) io.observe(i); });
      };
      watch();
      if (mq.addEventListener) mq.addEventListener('change', watch); else if (mq.addListener) mq.addListener(watch);
    } catch (err) { all(); }
  }

  /* ---------- Galerie : points sous les photos (mobile, photos pleine largeur ou qui dépassent) ---------- */
  function initGallery(root) {
    const gal = $('.gal', root);
    const dots = $$('.gal-d i', root);
    if (gal) lazyGallery(gal);
    if (!gal || dots.length < 2) return;
    let raf = 0;
    const sync = () => {
      raf = 0;
      const figs = gal.children;
      if (!figs.length || !figs[0].offsetWidth) return;
      const step = figs.length > 1 ? (figs[1].offsetLeft - figs[0].offsetLeft) : figs[0].offsetWidth;
      if (!step) return;
      const atEnd = gal.scrollLeft + gal.clientWidth >= gal.scrollWidth - 2;
      const i = atEnd ? dots.length - 1 : Math.min(dots.length - 1, Math.round(gal.scrollLeft / step));
      dots.forEach((d, j) => d.classList.toggle('on', j === i));
    };
    gal.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(sync); }, { passive: true });
  }

  /* ---------- Bloc d'achat parfum : 1 / 3 / 5 et choix avec quantités ---------- */
  function initBuy(root, cfg) {
    const t = cfg.text || {};
    const id = cfg.key;
    const P = cfg.perfumes || {};
    /* Le parfum de la fiche utilise la variante affichée (précommande : toujours disponible). */
    if (P[id]) {
      if (cfg.variantId) P[id].variantId = cfg.variantId;
      P[id].available = true;
    }
    /* Ordre des six : celui des réglages du thème (ordre des clés de « perfumes »). */
    const order = (cfg.order || Object.keys(P)).filter((k) => P[k]);
    const ok = (k) => !!(P[k] && P[k].variantId && P[k].available !== false);
    const capOf = (k) => (P[k] && P[k].cap) || k;
    const TOTAL = { one: 1, trio: 3, five: 5 };

    /* Ordre de remplissage par défaut : le parfum de la fiche, son accord, puis les autres. */
    const prefs = [id, cfg.duo].concat(order).filter((k, i, a) => k && a.indexOf(k) === i && ok(k));

    /* V3.7 : formule cochée à l'ouverture (réglage du thème) ; un lien de pub ?pack=3 ou ?pack=5 la remplace. */
    let m0 = TOTAL[cfg.mode] ? cfg.mode : 'one';
    if (cfg.urlPack !== false) {
      try {
        const q = String(new URLSearchParams(window.location.search).get('pack') || '').toLowerCase();
        const qm = { 1: 'one', 3: 'trio', 5: 'five', one: 'one', trio: 'trio', five: 'five' }[q];
        if (qm) m0 = qm;
      } catch (e) {}
    }
    const st = { mode: m0, units: [], busy: false };

    const segs = $$('[data-mode]', root);
    const box = $('[data-pick-box]', root) || $('.pick', root);
    const pickTitle = $('[data-pick-title]', root);
    const pickCount = $('[data-pick-count]', root);
    const pickBar = $('[data-pick-bar]', root);
    const pickSame = $('[data-pick-same]', root);
    const pickS = $('.pick-s', root);
    const tiles = $$('[data-pick]', root);
    const cta = $('[data-main-cta]', root);
    const ctaPrice = $('[data-cta-price]', root);
    const stickyP = $('[data-sticky-price]', root);
    const saveL = $('[data-save-line]', root);
    const stickyBar = $('.sticky', root);
    const stickyCta = $('[data-sticky-cta]', root);
    const stickyPick = $('[data-sticky-pick]', root);
    /* V3.11 : amener le visiteur à « Composez vos parfums » (bouton de la barre avant qu'il ait vu ce choix). */
    function goPick() {
      const tg = (box && !box.hidden) ? box : ($('.segs', root) || box);
      if (!tg) return;
      const y = tg.getBoundingClientRect().top + (window.pageYOffset || 0) - 84;
      window.scrollTo({ top: Math.max(0, y), behavior: reduced() ? 'auto' : 'smooth' });
    }
    /* V3.11 : amener le visiteur au choix 1, 3 ou 5 parfums (bouton de la barre, bande « Offre d'hiver »). */
    function goLots() {
      const tg = $('.segs', root) || box;
      if (!tg) return;
      const y = tg.getBoundingClientRect().top + (window.pageYOffset || 0) - 84;
      window.scrollTo({ top: Math.max(0, y), behavior: reduced() ? 'auto' : 'smooth' });
    }
    const total = () => TOTAL[st.mode] || 1;
    const multi = () => total() > 1;

    tiles.forEach((li) => {
      if (ok(li.dataset.pick)) return;
      li.classList.add('off');
      $$('button', li).forEach((b) => { b.disabled = true; });
    });

    function renderBar(n, grouped) {
      if (!pickBar) return;
      const free = Pick.freeSlots(n);
      pickBar.style.setProperty('--n', n);
      pickBar.innerHTML = '';
      for (let i = 0; i < n; i++) {
        const seg = document.createElement('i');
        const k = grouped[i];
        if (k) {
          seg.className = 'on';
          seg.style.setProperty('--c', (P[k] && P[k].deep) || 'var(--ink)');
        }
        if (free.includes(i) && t.free) {
          seg.classList.add('g');
          seg.setAttribute('data-l', t.free);
        }
        pickBar.appendChild(seg);
      }
    }

    function render() {
      const n = total();
      const units = st.units;
      const c = Pick.counts(units);
      const missing = multi() ? Math.max(0, n - units.length) : 0;

      segs.forEach((b) => {
        const on = b.dataset.mode === st.mode;
        b.classList.toggle('on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });

      if (box) box.hidden = !multi();
      if (multi()) {
        if (pickTitle) pickTitle.textContent = n === 3 ? t.pickTitle3 : t.pickTitle5;
        if (pickCount) {
          pickCount.textContent = fill(t.count, { n: units.length, total: n });
          pickCount.classList.toggle('ok', !missing);
        }
        renderBar(n, Pick.grouped(units));
        if (pickSame) {
          const label = fill(t.same, { n, parfum: capOf(id) });
          pickSame.textContent = label;
          pickSame.hidden = !label || !ok(id);
          pickSame.setAttribute('aria-pressed', (c[id] || 0) === n ? 'true' : 'false');
        }
        tiles.forEach((li) => {
          const k = li.dataset.pick;
          const q = c[k] || 0;
          li.classList.toggle('on', q > 0);
          const out = $('[data-pick-n]', li);
          if (out) out.textContent = String(q);
          const badge = $('[data-pick-badge]', li);
          if (badge) badge.textContent = q ? '×' + q : '';
          const minus = $('[data-pick-minus]', li);
          const plus = $('[data-pick-plus]', li);
          if (minus) minus.disabled = !ok(k) || q === 0;
          if (plus) plus.disabled = !ok(k) || q >= n;
        });
        if (pickS) {
          if (missing) pickS.textContent = fill(t.remaining, { n: missing });
          else {
            pickS.textContent = Pick.summary(Pick.grouped(units), capOf);
            if (n === 5 && t.pochette) appendStruck(pickS, ' ' + t.pochette);
          }
        }
      }

      if (cta) {
        cta.classList.toggle('is-off', missing > 0);
        if (missing > 0) cta.setAttribute('aria-disabled', 'true'); else cta.removeAttribute('aria-disabled');
      }
      if (ctaPrice && t.cta) ctaPrice.innerHTML = t.cta[st.mode] || '';
      if (stickyP && t.sticky) stickyP.innerHTML = t.sticky[st.mode] || '';
      if (saveL && t.save) { const h = t.save[st.mode] || ''; saveL.innerHTML = h; saveL.hidden = !h; }
      if (stickyBar) stickyBar.classList.toggle('is-multi', multi());
      if (stickyCta && t.cta) stickyCta.innerHTML = t.cta[st.mode] || '';
      if (stickyPick && t.stickyPick) stickyPick.textContent = fill(t.stickyPick, { n: total() });
    }

    function setMode(m) {
      if (!TOTAL[m]) return;
      st.mode = m;
      if (multi()) st.units = Pick.fit(st.units, total(), prefs);
      render();
    }

    function bump(li) {
      if (reduced() || !li) return;
      li.classList.remove('bump');
      void li.offsetWidth;
      li.classList.add('bump');
    }

    segs.forEach((b) => {
      b.addEventListener('click', () => setMode(b.dataset.mode));
      b.addEventListener('keydown', (e) => {
        const dir = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        const grp = segs.filter((x) => x.parentElement === b.parentElement);
        const i = (grp.indexOf(b) + dir + grp.length) % grp.length;
        setMode(grp[i].dataset.mode);
        grp[i].focus();
      });
    });

    if (box) {
      box.addEventListener('click', (e) => {
        const btn = e.target.closest('button');
        /* V3.11 : un appui sur la photo ou le nom d'un parfum l'ajoute, comme « + » (Clarity : 25 % des clics sans effet
           des fiches tombaient sur ces photos). */
        if (!btn) {
          const li0 = e.target.closest('[data-pick]');
          if (li0 && box.contains(li0) && e.target.closest('[data-pick-img], .lp-pt-n')) {
            const plus0 = $('[data-pick-plus]', li0);
            if (plus0 && !plus0.disabled) plus0.click();
          }
          return;
        }
        if (btn.disabled || !box.contains(btn)) return;
        if (btn.hasAttribute('data-pick-same')) {
          st.units = Pick.same(id, total());
          render();
          bump(tiles.find((li) => li.dataset.pick === id));
          return;
        }
        const li = btn.closest('[data-pick]');
        if (!li) return;
        const k = li.dataset.pick;
        if (!ok(k)) return;
        if (btn.hasAttribute('data-pick-plus')) {
          st.units = Pick.add(st.units, k, total(), id);
          bump(li);
        } else if (btn.hasAttribute('data-pick-minus')) {
          st.units = Pick.remove(st.units, k);
        }
        render();
      });
    }

    function buy(e) {
      if (e) e.preventDefault();
      if (st.busy) return;
      /* V3.11 : bouton de la barre avant que le visiteur ait vu le choix de la formule : on l'y amène. */
      const bar = e && e.currentTarget && e.currentTarget.closest ? e.currentTarget.closest('.sticky') : null;
      if (bar && multi() && bar.classList.contains('is-pick')) { goPick(); return; }
      const n = total();
      const units = multi() ? st.units : [id];
      if (multi() && units.length < n) {
        const m = n - units.length;
        if (box) box.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
        toast(fill(m > 1 ? t.toastMany : t.toastOne, { n: m }));
        return;
      }
      const items = Pick.items(units, (k) => (k === id ? cfg.variantId : P[k] && P[k].variantId));
      if (!items.length) return;
      st.busy = true;
      root.setAttribute('aria-busy', 'true');
      addItems(items)
        .catch(() => { if (!hasLP()) toast(t.error); })
        .then(() => { st.busy = false; root.removeAttribute('aria-busy'); });
    }
    $$('[data-lp-buy]', root).forEach((b) => b.addEventListener('click', buy));

    /* V3.11 : la bande « Offre d'hiver » de la fiche mène au choix de la formule (2 + 1 si « 1 parfum » était coché). */
    const strip = $('.buy .lp-hv-strip', root);
    if (strip && segs.length) {
      strip.setAttribute('role', 'button');
      strip.tabIndex = 0;
      const goOffer = () => { if (st.mode === 'one' && TOTAL.trio) setMode('trio'); goLots(); };
      strip.addEventListener('click', goOffer);
      strip.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goOffer(); } });
    }

    setMode(st.mode);
  }

  /* ---------- Barre d'achat collante ----------
     Ordinateur : visible quand le bouton principal est passé (comme avant).
     V3.11, téléphone (Clarity : 25 % seulement des visiteurs atteignaient le bouton) : visible dès 160 px de défilement,
     chaque fois que le bouton principal n'est pas à l'écran. Tant que le visiteur n'a vu ni le choix de la formule ni le
     bouton (classe is-pick), le bouton de la barre l'amène au choix au lieu d'ajouter des parfums qu'il n'a pas choisis. */
  function initSticky(root) {
    const cta = $('[data-main-cta]', root);
    const sticky = $('.sticky', root);
    if (!cta || !sticky || !('IntersectionObserver' in window)) return;
    const mq = window.matchMedia ? window.matchMedia('(max-width: 899px)') : null;
    const pick = $('[data-pick-box]', root);
    let ctaIn = false;
    let ctaAbove = false;
    let seen = false;
    const set = () => {
      const early = !!(mq && mq.matches) && (window.pageYOffset || 0) > 160;
      const on = !ctaIn && (ctaAbove || early);
      sticky.classList.toggle('on', on);
      sticky.classList.toggle('is-pick', !seen);
      document.body.classList.toggle('has-sticky', on);
    };
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      ctaIn = e.isIntersecting;
      ctaAbove = !e.isIntersecting && e.boundingClientRect.top < 0;
      if (e.isIntersecting && pick && !pick.hidden) seen = true;
      set();
    }), { threshold: 0.25 });
    io.observe(cta);
    if (pick) {
      const io2 = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting && !pick.hidden) { seen = true; set(); } }), { threshold: 0.35 });
      io2.observe(pick);
      root.__lpIO2 = io2;
    }
    let queued = false;
    const onScroll = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; set(); }); };
    window.addEventListener('scroll', onScroll, { passive: true });
    root.__lpScroll = onScroll;
    root.__lpIO = io;
    set();
  }

  /* ---------- Produit hors parfums (ex. pochette) ---------- */
  function initGeneric(root) {
    const form = $('form[data-lp-form]', root);
    if (!form) return;
    const variants = readJSON($('[data-lp-variants]', root)) || [];
    const txt = readJSON($('[data-lp-generic-text]', root)) || {};
    const select = $('[data-lp-variant]', form);
    const btn = $('[data-lp-add]', form);
    const label = $('[data-lp-add-label]', form);
    const bPrice = $('[data-lp-add-price]', form);
    const price = $('[data-lp-price]', root);
    if (select) select.addEventListener('change', () => {
      const v = variants.find((x) => String(x.id) === select.value);
      if (!v) return;
      if (price) price.textContent = v.price;
      if (bPrice) bPrice.textContent = v.price;
      if (btn) btn.disabled = !v.available;
      if (label) label.textContent = v.available ? txt.add : txt.soldout;
    });
    form.addEventListener('submit', (e) => {
      if (!hasLP()) return;
      e.preventDefault();
      const idEl = form.querySelector('[name="id"]');
      const qEl = form.querySelector('[name="quantity"]');
      const vid = Number(idEl && idEl.value);
      if (!vid) return;
      if (btn) btn.setAttribute('aria-busy', 'true');
      Promise.resolve(LP.cart.add([{ id: vid, quantity: Math.max(1, Number(qEl && qEl.value) || 1) }], { open: true }))
        .catch(() => {})
        .then(() => { if (btn) btn.removeAttribute('aria-busy'); });
    });
  }

  /* ---------- « Cliquez pour sentir » (V8 : images préchargées, défilement continu sans saut) ----------
     Le modèle est cloné et complété une seule fois (fillSmell), ses images sont téléchargées et décodées à l'avance
     (warmSmell) ; à l'ouverture, chaque colonne défile d'exactement une copie de ses images (voir theme.css,
     .st-track), à la vitesse réglée en px par seconde. Pause : doigt posé ou bouton de souris enfoncé, onglet masqué.
     Pas de pause au survol : la fenêtre s'ouvre sous la souris et le défilement resterait arrêté sur ordinateur. */
  let smell = null; /* { box, opener, root, token } */
  const ST_FACTORS = [1, 1.18, 0.88, 1.08];
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));

  function fillSmell(scope, key) {
    /* Textes et notes repris de la section « Parcours sur la peau » quand elle est sur la page. */
    const pc = document.querySelector('.pc[data-p="' + key + '"]') || document.querySelector('.pc');
    const like = $('.st-like', scope);
    const src = pc && $('.pc-like', pc);
    if (like) {
      if (src && src.textContent.trim()) like.textContent = src.textContent.trim();
      else if (!like.textContent.trim()) like.remove();
    }
    $$('.st-tile[data-k]', scope).forEach((fig) => {
      const step = pc && $('.pc-step[data-k="' + fig.dataset.k + '"]', pc);
      if (!step) return;
      const from = $('.pc-img img', step);
      const to = $('img', fig);
      if (from && to) {
        /* Même image que le parcours ; la taille d'affichage (sizes) de la tuile est conservée. */
        const s1 = from.getAttribute('src');
        const s2 = from.getAttribute('srcset');
        if (s1) to.setAttribute('src', s1);
        if (s2) to.setAttribute('srcset', s2); else to.removeAttribute('srcset');
      }
      const notes = $('.pc-notes', step);
      const words = notes ? notes.textContent.split(',').map((w) => w.trim()).filter(Boolean) : [];
      if (words.length && !$('figcaption', fig)) {
        const cap = document.createElement('figcaption');
        words.forEach((w) => { const s = document.createElement('span'); s.textContent = w; cap.appendChild(s); });
        fig.appendChild(cap);
      }
    });
  }

  /* Fenêtre prête à l'emploi (une fois par fiche) : images en chargement immédiat, priorité basse. */
  function smellFragment(root, key) {
    if (root.__smellFrag && root.__smellKey === key) return root.__smellFrag;
    const tpl = $('template[data-smell-tpl]', root);
    if (!tpl) return null;
    const frag = tpl.content.cloneNode(true);
    fillSmell(frag, key);
    $$('img', frag).forEach((img) => {
      img.setAttribute('loading', 'eager');
      img.setAttribute('decoding', 'async');
      img.setAttribute('fetchpriority', 'low');
    });
    root.__smellFrag = frag;
    root.__smellKey = key;
    root.__smellWarm = null;
    return frag;
  }

  /* Télécharge et décode chaque image une seule fois, avant le premier mouvement. */
  function warmSmell(root, key) {
    const frag = smellFragment(root, key);
    if (!frag) return Promise.resolve();
    if (root.__smellWarm) return root.__smellWarm;
    const seen = new Set();
    const jobs = [];
    $$('.st-set:not([aria-hidden]) img', frag).forEach((src) => {
      const id = (src.getAttribute('srcset') || '') + '|' + (src.getAttribute('src') || '');
      if (seen.has(id)) return;
      seen.add(id);
      const im = new Image();
      im.decoding = 'async';
      const sz = src.getAttribute('sizes');
      const ss = src.getAttribute('srcset');
      if (sz) im.sizes = sz;
      if (ss) im.srcset = ss;
      im.src = src.getAttribute('src') || '';
      const done = im.decode ? im.decode() : new Promise((r) => { im.onload = r; im.onerror = r; });
      jobs.push(done.catch(() => {}));
    });
    root.__smellWarm = Promise.all(jobs);
    return root.__smellWarm;
  }

  /* Durée de chaque colonne = hauteur d'une copie / vitesse (px par seconde), départs décalés. */
  function tuneSmell(box) {
    const st = $('.st', box);
    const speed = Math.max(4, parseFloat(st && st.dataset.speed) || 32);
    $$('.st-col', box).forEach((col, i) => {
      const track = $('.st-track', col);
      const set = track && track.firstElementChild;
      const h = set ? set.offsetHeight : 0;
      if (!h) return; /* colonne masquée à cette largeur */
      const dur = h / (speed * ST_FACTORS[i % ST_FACTORS.length]);
      track.style.setProperty('--st-dur', dur.toFixed(2) + 's');
      track.style.setProperty('--st-delay', (-dur * ((0.21 + i * 0.37) % 1)).toFixed(2) + 's');
    });
  }

  function smellHold(on) { if (smell) smell.box.classList.toggle('is-held', on); }

  function openSmell(trigger) {
    const root = trigger.closest('[data-lp-product]');
    const box = root && root.__smellBox;
    const key = trigger.dataset.smell;
    const frag = root && smellFragment(root, key);
    if (!box || !frag) return;
    if (smell) closeSmell(true, true);
    const warm = warmSmell(root, key);
    clearTimeout(box.__hideT);
    box.classList.remove('on', 'is-run', 'is-held', 'is-hidden');
    box.innerHTML = '';
    box.appendChild(frag.cloneNode(true));
    box.hidden = false;
    if (window.LP && typeof LP.lock === 'function') LP.lock(); else document.body.classList.add('lock');
    const token = {};
    smell = { box, opener: trigger, root, token };
    requestAnimationFrame(() => { if (smell && smell.token === token) box.classList.add('on'); });
    const x = $('.st-x', box);
    if (x) { try { x.focus({ preventScroll: true }); } catch (e) { x.focus(); } }
    /* Démarrage quand les images sont prêtes (au plus 0,9 s d'attente, la fenêtre apparaît pendant ce temps). */
    Promise.race([warm, wait(900)]).then(() => {
      if (!smell || smell.token !== token) return;
      tuneSmell(box);
      requestAnimationFrame(() => { if (smell && smell.token === token) box.classList.add('is-run'); });
    });
  }

  function closeSmell(silent, instant) {
    if (!smell) return;
    const { box, opener } = smell;
    smell = null;
    box.classList.remove('on', 'is-held');
    const finish = () => {
      if (smell && smell.box === box) return; /* rouverte entre-temps */
      box.hidden = true;
      box.innerHTML = '';
      box.classList.remove('is-run', 'is-hidden');
      if (window.LP && typeof LP.unlock === 'function') LP.unlock();
      else if (!document.querySelector('.drawer.open, .menu.open, .modal:not([hidden])')) document.body.classList.remove('lock');
    };
    clearTimeout(box.__hideT);
    if (instant || reduced()) finish();
    else box.__hideT = setTimeout(finish, 380);
    if (!silent && opener && document.contains(opener)) opener.focus();
  }

  document.addEventListener('click', (e) => {
    const t = e.target.closest && e.target.closest('[data-smell], [data-stclose], [data-add-variant]');
    if (!t) return;
    if (t.hasAttribute('data-smell')) { e.preventDefault(); openSmell(t); return; }
    if (t.hasAttribute('data-stclose')) { e.preventDefault(); closeSmell(); return; }
    /* « Ajouter » dans la fenêtre : l'ajout est géré par theme.js, on ferme ensuite la fenêtre. */
    if (smell && smell.box.contains(t)) setTimeout(() => closeSmell(true), 0);
  });

  /* Doigt posé ou bouton de souris enfoncé sur les images : pause, reprise au relâchement. */
  document.addEventListener('pointerdown', (e) => { if (smell && e.target.closest && e.target.closest('.st-cols') && smell.box.contains(e.target)) smellHold(true); });
  ['pointerup', 'pointercancel'].forEach((ev) => document.addEventListener(ev, () => smellHold(false)));
  document.addEventListener('visibilitychange', () => { if (smell) smell.box.classList.toggle('is-hidden', document.hidden); });
  let stResize;
  window.addEventListener('resize', () => {
    if (!smell) return;
    clearTimeout(stResize);
    stResize = setTimeout(() => { if (smell) tuneSmell(smell.box); }, 200);
  });

  /* Préchargement discret : au survol ou au toucher du bouton, ou au repos après le chargement de la page
     (sauf mode économie de données). */
  function prepSmell(root) {
    const btn = $('[data-smell]', root);
    if (!btn || !$('template[data-smell-tpl]', root)) return;
    const go = () => warmSmell(root, btn.dataset.smell);
    ['pointerenter', 'touchstart', 'focus'].forEach((ev) => btn.addEventListener(ev, go, { once: true, passive: true }));
    const c = navigator.connection;
    if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return;
    const idle = () => (window.requestIdleCallback ? requestIdleCallback(go, { timeout: 4000 }) : setTimeout(go, 1500));
    if (document.readyState === 'complete') setTimeout(idle, 1200);
    else window.addEventListener('load', () => setTimeout(idle, 1200), { once: true });
  }

  document.addEventListener('keydown', (e) => {
    if (!smell) return;
    if (e.key === 'Escape') { closeSmell(); return; }
    if (e.key === 'Tab') {
      const f = $$('button, a[href], [tabindex]:not([tabindex="-1"])', smell.box).filter((el) => !el.disabled && el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!smell.box.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Initialisation ---------- */
  function init(root) {
    if (!root || root.__lpInit) return;
    root.__lpInit = true;
    /* La fenêtre « Cliquez pour sentir » est déplacée à la fin de <body> (comme en V3). */
    const box = $('.smell-box', root);
    if (box) { root.__smellBox = box; document.body.appendChild(box); prepSmell(root); }
    initGallery(root);
    if (root.hasAttribute('data-lp-generic')) { initGeneric(root); return; }
    const cfg = readJSON($('[data-lp-config]', root));
    if (cfg) initBuy(root, cfg);
    initSticky(root);
  }

  function boot(scope) {
    $$('[data-lp-product]', scope).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);

  /* Éditeur de thème : réinitialiser une section rechargée (theme.js gère les apparitions .in). */
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    $$('[data-lp-product]', e.target).forEach((root) => {
      if (root.__lpIO) root.__lpIO.disconnect();
      if (root.__lpIO2) root.__lpIO2.disconnect();
      if (root.__lpScroll) window.removeEventListener('scroll', root.__lpScroll);
      if (smell && smell.root === root) closeSmell(true, true);
      if (root.__smellBox) root.__smellBox.remove();
    });
    document.body.classList.remove('has-sticky');
  });
  /* Éditeur : ouvrir la question « Avant d'acheter » sélectionnée. */
  document.addEventListener('shopify:block:select', (e) => {
    const d = e.target;
    if (d && d.matches && d.matches('details.lp-ob-i')) d.open = true;
  });
})();
